import React, { useState } from 'react'
import { spacing } from '@vacationtracker/shared/constants/ThemeSetting'

import { Banner } from '../../design-system/Banner'
import type { BannerAction } from '../../design-system/Banner'

export interface MovedNoteProps {
  storageKey: string
  message: React.ReactNode
  action?: BannerAction
}

function readDismissed(storageKey: string): boolean {
  try {
    return localStorage.getItem(storageKey) === 'true'
  } catch {
    return false
  }
}

/** A closable note that something moved; once closed it stays closed in this browser. */
export function MovedNote({ storageKey, message, action }: MovedNoteProps): React.ReactElement | null {
  const [dismissed, setDismissed] = useState(() => readDismissed(storageKey))
  if (dismissed) {
    return null
  }
  const onClose = () => {
    try {
      localStorage.setItem(storageKey, 'true')
    } catch {
      // Storage blocked: the note still hides for this visit
    }
    setDismissed(true)
  }
  return (
    <div style={{ marginBottom: spacing.base }}>
      <Banner tone="info" closable onClose={onClose} message={message} action={action} />
    </div>
  )
}

export default MovedNote
